// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__12VmU","links-logos":"Footer_links-logos__1fBbS","copyright":"Footer_copyright__sR80m"};